import { render, staticRenderFns } from "./HighlightCard.vue?vue&type=template&id=6467348f&scoped=true"
import script from "./HighlightCard.vue?vue&type=script&lang=js"
export * from "./HighlightCard.vue?vue&type=script&lang=js"
import style0 from "./HighlightCard.vue?vue&type=style&index=0&id=6467348f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6467348f",
  null
  
)

export default component.exports